// ������� ��� ������������ ������ �� ������������� ����� �� ������� �����
export default function ruPluralize(number, strings) {
    // ���������, ���� �� � ��� ������ ����� (0, 1, 2-4, �������������)
    if (strings.length === 4) {
        // ���� ����� ����� 0, ���������� ����� ��� ����
        if (number === 0) {
            return strings[0];
        }

        // ������� ������ ������� (����� ��� 0), ��� ��� ��� ��� ������ �� �����
        strings.shift();
    }

    // �������� ����� � ��������� �� 0 �� 99
    number = number % 100;

    // ���� ����� ������ 20, �������� ��� � ��������� �� 0 �� 9
    if (number > 20) {
        number = number % 10;
    }

    // ���� ����� ����� 1, ���������� ����� ��� ������������� �����
    if (number === 1) {
        return strings[0];
    }

    // ���� ����� ������ 1 � ������ 5, ���������� ����� ��� 2-4
    if (number > 1 && number < 5) {
        return strings[1];
    }

    // ���������� ����� ��� �������������� ����� (5 � �����)
    return strings[2];
}
